<template>
  <div class="animated fadeIn">
    <b-card-group class="mb-4">
      <b-card class="col-sm-12 col-md-3 col-lg-3">
        <div class="h4 text-muted text-right">
          <i class="icon-people"></i>&nbsp;Total Konsumen
        </div>
        <div class="small text-muted text-right mb-4">Based on status</div>

        <div class="chart-wrapper" v-if="!loading">
          <doughnut-example
            :key="uniqueId('customer-status')"
            :doughnut-label="customer_status.label"
            :doughnut-data="customer_status.data"
            :doughnut-color="customer_status.color"
            chartId="customer-status-01"
          ></doughnut-example>
          <br />
          <table-total
            :tableData="customer_status"
            :title="'customer_status'"
          ></table-total>
        </div>
        <loading v-else></loading>
      </b-card>

      <b-card class="col-sm-12 col-md-3 col-lg-3">
        <div class="h4 text-muted text-right">
          <i class="icon-people"></i>&nbsp;Total Konsumen
        </div>
        <div class="small text-muted text-right mb-4">
          Based on GT and Non GT
        </div>

        <div class="chart-wrapper" v-if="!loading">
          <doughnut-example
            :key="uniqueId('customer-gt-nongt')"
            :doughnut-label="customer_gt_nongt.label"
            :doughnut-data="customer_gt_nongt.data"
            :doughnut-color="customer_gt_nongt.color"
            chartId="customer-gt-nongt-01"
          ></doughnut-example>
          <br />
          <table-total
            :tableData="customer_gt_nongt"
            :title="'customer_gt_nongt'"
          ></table-total>
        </div>
        <loading v-else></loading>
      </b-card>
    </b-card-group>

    <b-card-group class="mb-4">
      <!-- GRAFIK TOTAL NON GT -->
      <b-card class="col-sm-12 col-md-3 col-lg-3">
        <div class="h4 text-muted text-right">
          <i class="icon-people"></i>&nbsp;Total Non GT
        </div>
        <div class="small text-muted text-right mb-4">
          Based on Rute & Mandatory belum lengkap
        </div>

        <div class="chart-wrapper" v-if="!loading">
          <doughnut-example
            :key="uniqueId('customer-no-route')"
            :doughnut-label="customer_no_route.label"
            :doughnut-data="customer_no_route.data"
            :doughnut-color="customer_no_route.color"
            chartId="customer-no-route-01"
          ></doughnut-example>
          <br />
          <table-total
            :clickAble="true"
            :tableData="customer_no_route"
            :title="'customer_no_route'"
            @showDetail="showDetail"
          ></table-total>
        </div>
        <loading v-else></loading>
      </b-card>

      <!-- TABEL TOTAL NON GT -->
      <b-card class="col-sm-12 col-md-9 col-lg-9">
        <div class="h4 text-muted text-right">
          <i class="icon-home"></i>&nbsp;Tabel Toko Non-GT
        </div>
        <div
          class="small text-muted text-right mb-4"
          v-if="!loading_total_non_gt"
        >
          <!-- 
            showNameNonGT itu isinya antara:
            1. Rute Belum Ada
            2. Mandatory Belum Lengkap
          -->
          List toko <b>Non GT</b> yang <b>{{ showNameNonGT }}</b>
        </div>

        <div class="chart-wrapper">
          <b-button
            v-if="!loading_total_non_gt"
            class="btn btn-link"
            variant="excel icon"
            size="sm"
            @click="downloadTotalNonGT"
            ><i class="fa fa-file-excel-o"></i> Export to excel</b-button
          >
          <global-table
            :table-data="total_non_gt"
            :loading="loading_total_non_gt"
            :per-page="10"
            :bordered="true"
            :table-detail="tableDetail"
            :hover="true"
            :striped="false"
            :fields="fields_total_non_gt"
            :redirect-detail="false"
            :show-add-button="false"
            :edit-button="false"
          ></global-table>
        </div>
      </b-card>
    </b-card-group>

    <b-card-group class="mb-4">
      <!-- GRAFIK TOTAL GT -->
      <b-card class="col-sm-12 col-md-3 col-lg-3">
        <div class="h4 text-muted text-right">
          <i class="icon-people"></i>&nbsp;Total GT
        </div>
        <div class="small text-muted text-right mb-4">
          Based on Rute & Mandatory belum lengkap
        </div>

        <div class="chart-wrapper" v-if="!loading">
          <doughnut-example
            :key="uniqueId('customer-no-route')"
            :doughnut-label="mandatory_customer_gt.label"
            :doughnut-data="mandatory_customer_gt.data"
            :doughnut-color="mandatory_customer_gt.color"
            chartId="customer-no-route-01"
          ></doughnut-example>
          <br />
          <table-total
            :clickAble="true"
            :tableData="mandatory_customer_gt"
            :title="'mandatory_customer_gt'"
            @showDetail="showDetail2"
          ></table-total>
        </div>
        <loading v-else></loading>
      </b-card>

      <!-- TABEL TOTAL GT -->
      <b-card class="col-sm-12 col-md-9 col-lg-9">
        <div class="h4 text-muted text-right">
          <i class="icon-home"></i>&nbsp;Tabel Toko GT
        </div>
        <div
          class="small text-muted text-right mb-4"
          v-if="!loading_total_gt"
        >
          <!-- 
            showNameGT itu isinya antara:
            1. Rute Belum Ada
            2. Mandatory Belum Lengkap
          -->
          List toko <b>GT</b> yang <b>{{ showNameGT }}</b>
        </div>

        <div class="chart-wrapper">
          <b-button
            v-if="!loading_total_non_gt"
            class="btn btn-link"
            variant="excel icon"
            size="sm"
            @click="downloadTotalGT"
            ><i class="fa fa-file-excel-o"></i> Export to excel</b-button
          >
          <global-table
            :table-data="total_gt"
            :loading="loading"
            :per-page="7"
            :bordered="true"
            :table-detail="tableDetail"
            :hover="true"
            :striped="false"
            :fields="fields_total_gt"
            :redirect-detail="false"
            :show-add-button="false"
            :edit-button="false"
          ></global-table>
        </div>
      </b-card>
    </b-card-group>

    <b-card-group class="mb-4">
      <b-card class="col-sm-12 col-md-4 col-lg-4">
        <div class="h4 text-muted text-right">
          <i class="icon-people"></i>&nbsp;Total Konsumen
        </div>
        <div class="small text-muted text-right mb-4">Based on group</div>

        <div class="chart-wrapper" v-if="!loading">
          <doughnut-example
            :key="uniqueId('customer-group')"
            :doughnut-label="customer_group.label"
            :doughnut-data="customer_group.data"
            :doughnut-color="customer_group.color"
            chartId="customer-group-01"
          ></doughnut-example>
          <br />
          <table-total
            :tableData="customer_group"
            :title="'customer_group'"
          ></table-total>
        </div>
        <loading v-else></loading>
      </b-card>

      <b-card class="col-sm-12 col-md-4 col-lg-4">
        <div class="h4 text-muted text-right">
          <i class="icon-people"></i>&nbsp;Total Konsumen
        </div>
        <div class="small text-muted text-right mb-4">
          Yang tidak pernah order
        </div>

        <div class="chart-wrapper" v-if="!loading">
          <doughnut-example
            :key="uniqueId('customer-no-order')"
            :doughnut-label="customer_no_order.label"
            :doughnut-data="customer_no_order.data"
            :doughnut-color="customer_no_order.color"
            chartId="customer-no-order-01"
          ></doughnut-example>
          <br />
          <table-total
            :tableData="customer_no_order"
            :title="'customer_no_order'"
          ></table-total>
        </div>
        <loading v-else></loading>
      </b-card>

      <b-card class="col-sm-12 col-md-4 col-lg-4">
        <div class="h4 text-muted text-right">
          <i class="icon-people"></i>&nbsp;Total Konsumen in DC
        </div>
        <div class="small text-muted text-right mb-4">Based On DC</div>

        <div class="chart-wrapper" v-if="!loading">
          <doughnut-example
            v-if="customer_in_dc[0]"
            :key="uniqueId('customer-total-dc')"
            :doughnut-label="customer_in_dc[0].label"
            :doughnut-data="customer_in_dc[0].data"
            :doughnut-color="customer_in_dc[0].color"
            chartId="customer-total-dc-01"
          ></doughnut-example>
          <br />
          <table-total
            :tableData="customer_in_dc[0]"
            :title="'customer_in_dc'"
          ></table-total>
        </div>
        <loading v-else></loading>
      </b-card>
    </b-card-group>

    <b-card-group class="mb-4">
      <b-card class="col-sm-12 col-md-6 col-lg-6">
        <div class="h4 text-muted text-right">
          <i class="icon-people"></i>&nbsp;Total Konsumen in DC
        </div>
        <div class="small text-muted text-right mb-4">Based On Mitra DC</div>

        <div class="chart-wrapper" v-if="!loading">
          <doughnut-example
            v-if="customer_in_dc[1]"
            :key="uniqueId('customer-total-dc2')"
            :doughnut-label="customer_in_dc[1].label"
            :doughnut-data="customer_in_dc[1].data"
            :doughnut-color="customer_in_dc[1].color"
            chartId="customer-total-dc-02"
          ></doughnut-example>
          <br />
          <table-total
            :tableData="customer_in_dc[1]"
            :title="'customer_in_dc1'"
          ></table-total>
        </div>
        <loading v-else></loading>
      </b-card>
      <b-card class="col-sm-12 col-md-6 col-lg-6">
        <div class="h4 text-muted text-right">
          <i class="icon-people"></i>&nbsp;Total Konsumen in DC
        </div>
        <div class="small text-muted text-right mb-4">
          Based On Rute Pengiriman
        </div>

        <div class="chart-wrapper" v-if="!loading">
          <doughnut-example
            v-if="customer_in_dc[1]"
            :key="uniqueId('customer-total-dc3')"
            :doughnut-label="customer_in_dc[2].label"
            :doughnut-data="customer_in_dc[2].data"
            :doughnut-color="customer_in_dc[2].color"
            chartId="customer-total-dc-03"
          ></doughnut-example>
          <br />
          <table-total
            :tableData="customer_in_dc[2]"
            :title="'customer_in_dc3'"
          ></table-total>
        </div>
        <loading v-else></loading>
      </b-card>
    </b-card-group>

    <b-card-group class="mb-12">
      <b-card class="col-sm-12 col-md-12 col-lg-12">
        <div class="h4 text-muted text-right">
          <i class="icon-home"></i>&nbsp;Akhir Kontrak
        </div>
        <div  class="small text-muted text-right mb-4" >
          <b>List akhir penjanjian kontrak freezer</b>
          <br/>
           <b-button
            v-if="!loading_asset_no_used"
            class="btn btn-link"
            style="padding: 0.25rem 0rem"
            variant="excel icon"
            size="sm"
            @click="downloadExpiredFreezer"
            ><i class="fa fa-file-excel-o"></i> Export to excel</b-button
          >
        </div>
        
        <global-table
          :table-data="customer_expired_freezer"
          :loading="loading || loading_asset_no_used"
          :per-page="20"
          :bordered="true"
          :table-detail="true"
          :hover="true"
          :striped="false"
          :fields="fields_customer_expired_freezer"
          :redirect-detail="false"
          :show-add-button="false"
          :edit-button="false"
          :filter-table-only="true"
        ></global-table>
      </b-card>
    </b-card-group>
  </div>
</template>

<script>
import { Callout } from "@coreui/vue";
import axios from "axios";
import globalTable from "@/templates/Table.vue";
import VueNotifications from "vue-notifications";
import loading from "@/templates/Loading.vue";
import LineExample from "@/views/charts/LineExample.vue";
import DoughnutExample from "@/views/charts/DoughnutExample.vue";
import BarExample from "@/views/charts/BarExample.vue";
import * as moment from "moment";
import { ModelSelect } from "vue-search-select";
import tableTotal from "@/templates/TableTotal.vue";

import _ from "lodash";

export default {
  name: "dashboard-customer",
  components: {
    globalTable,
    Callout,
    loading,
    ModelSelect,
    LineExample,
    DoughnutExample,
    BarExample,
    tableTotal
  },
  props: {
    tableDetail: {
      type: Boolean,
      default: true
    }
  },
  data: function() {
    return {
      loading: false,
      loading_asset_no_used: false,
      customer_status: [],
      customer_group: [],
      customer_gt_nongt: [],
      customer_no_route: [],
      customer_no_order: [],
      customer_in_dc: [],
      customer_expired_freezer: [],
      mandatory_customer_gt: [],
      currState2: 0,
      currState: 0,
      loading_total_non_gt: true,
      loading_total_gt: true,
      total_non_gt: [],
      total_gt: [],

      fields_total_non_gt: [
        { key: "name", label: "Nama Konsumen", sortable: true },
        {
          key: "address",
          label: "Alamat",
          sortable: true
        }
      ],

      fields_total_gt: [
        { key: "name", label: "Nama Konsumen", sortable: true },
        {
          key: "address",
          label: "Alamat",
          sortable: true
        }
      ],

      fields_customer_expired_freezer: [
        { key: "customer_name", label: "Nama Konsumen", sortable: true},
        { key: "dc_name", label: "DC Name", sortable: true},
        { key: "contract_number", label: "No Kontrak", sortable: true},
        { key: "placement_date", label: "Tanggal Penempatan", sortable: true},
        { key: "expired_date", label: "Tanggal Expired", sortable: true}
      ]
    };
  },
  notifications: {
    showErrorNotification: {
      title: "Error Title",
      message: "Messages",
      type: "error"
    },
    showInfoNotification: {
      title: "Info Title",
      message: "Messages",
      type: "info"
    }
  },
  computed: {
    //gimana caranya biar dapet nama dari tabel total yang udah di klik
    showNameNonGT() {
      let flag = "";
      for (let i in this.customer_no_route.label) {
        if (i == this.currState) {
          flag = this.customer_no_route.label[i];
        }
      }
      return flag;
    },

     showNameGT() {
      let flag = "";
      for (let i in this.mandatory_customer_gt.label) {
        if (i == this.currState2) {
          flag = this.mandatory_customer_gt.label[i];
        }
      }
      return flag;
    }
  },
  methods: {
    uniqueId: function(param = "") {
      return _.uniqueId(param);
    },
    init: function() {
      this.loading = true;
      this.axios
        .get("web/dashboard/all-dashboard-for-customer/")
        .then(response => {
          this.customer_status = response.data.customer_status;
          this.customer_group = response.data.customer_group;
          this.customer_gt_nongt = response.data.customer_gt_nongt;
          this.customer_no_route = response.data.customer_no_route;
          this.customer_no_order = response.data.customer_no_order;
          this.customer_in_dc = response.data.customer_in_dc;
          this.customer_expired_freezer = response.data.customer_expired_freezer;
          this.mandatory_customer_gt = response.data.mandatory_customer_gt;
        })
        .catch(error => {
          this.expired(error);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    expired: function(error) {
      if (error.response.status === 401) {
        localStorage.clear();
        this.$router.push({ path: "/login" });
        this.showErrorNotification({
          title: "Token Expired",
          message: "Your session has been expired"
        });
      } else {
        this.showErrorNotification({
          title: "Dashboard Konsumen",
          message: error.response.data.message
        });
      }
    },
    showDetail: function(state) {
      this.loading_total_non_gt = true;
      this.currState = state;
      this.axios
        .get("web/dashboard/total-non-gt/" + state + "/")
        .then(response => {
          this.total_non_gt = response.data.total_non_gt;
        })
        .catch(error => {})
        .finally(() => {
          this.loading_total_non_gt = false;
        });
      this.init();
    },
    showDetail2: function(state) {
      this.loading_total_gt = true;
      this.currState2 = state;
      this.axios
        .get("web/dashboard/total-gt/" + state + "/")
        .then(response => {
          this.total_gt = response.data.total_gt;
        })
        .catch(error => {})
        .finally(() => {
          this.loading_total_gt = false;
        });
      this.init();
    },

    downloadTotalNonGT: function() {
      this.loading_total_non_gt = true;
      var title = '';
      if(this.currState === '0') {
        title = 'rute_belum_lengkap';
      } else {
        title = 'mandatory_belum_lengkap';
      }
      this.axios({
        url:
          "web/export/customer/customer-non-gt/"+this.currState,
        method: "GET",
        responseType: "arraybuffer" //before "blob"
      })
        .then(response => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", "customer_list_non_gt_"+title+".xlsx");
          document.body.appendChild(link);
          link.click();
        })
        .catch(error => {
          if (error.response.status === 401) {
            this.expired(error, "");
          }
        })
        .finally(() => {
          this.loading_total_non_gt = false;
        });
    },
    downloadTotalGT: function() {
      this.loading_total_gt = true;
      var title = '';
      if(this.currState2 === '0') {
        title = 'gudang_asal_belum_lengkap';
      } else {
        title = 'mandatory_belum_lengkap';
      }
      this.axios({
        url:
          "web/export/customer/customer-gt/"+this.currState2,
        method: "GET",
        responseType: "arraybuffer" //before "blob"
      })
        .then(response => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", "customer_list_gt_"+title+".xlsx");
          document.body.appendChild(link);
          link.click();
        })
        .catch(error => {
          if (error.response.status === 401) {
            this.expired(error, "");
          }
        })
        .finally(() => {
          this.loading_total_gt = false;
        });
    },
    downloadExpiredFreezer: function() {
      this.loading_asset_no_used = true;
      this.axios({
        url:
          "web/export/asset/list-expired/",
        method: "GET",
        responseType: "arraybuffer" //before "blob"
      })
        .then(response => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", "asset_list_expired.xlsx");
          document.body.appendChild(link);
          link.click();
        })
        .catch(error => {
          if (error.response.status === 401) {
            this.expired(error, "");
          }
        })
        .finally(() => {
          this.loading_asset_no_used = false;
        });
    }
  },
  mounted() {
    //this.dropdown();

    this.showDetail(0);
    this.showDetail2(0);
    this.init();
  }
};
</script>
